// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__QHmn8","col":"CardReaderDesc_col__dKJLO","label":"CardReaderDesc_label__QCusy"};